<script setup>
import { defineProps, defineEmits, computed} from "vue";
import TabelaDePagamentosDeContasAPagar from "./PagamentosContasAPagar/TabelaDePagamentosDeContasAPagar.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
    "contaAPagar",
]);

const emits = defineEmits([
    "update:alteraPagamento",
]);

//==================================================================//
//======================== Altera Pagamento ========================//
//==================================================================//

const alteraPagamento = (update = {})=>{

    emits('update:alteraPagamento',update);

};

//==================================================================//
//======================= Mostra Pagamentos ========================//
//==================================================================//

let mostraPagamentos = computed(()=>{

    if(props?.contaAPagar?.pagamentosQuantidade <= 0){
        return false;
    }

    if(props?.contaAPagar?.aberto == false){
        return false;
    }

    return true;

});

</script>

<template>

    <div class="c-table__row"
        v-show="mostraPagamentos"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <TabelaDePagamentosDeContasAPagar
                    :controlesDesativados="props?.controlesDesativados"
                    :dado="props?.dado"
                    :contaAPagar="props?.contaAPagar"
                    @update:alteraPagamento="alteraPagamento"
                ></TabelaDePagamentosDeContasAPagar>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__row:hover{
    background-color: #eeeeee;
}

.c-table__cell{
    grid-column: 3 / -1;
}

</style>
